/**
 * Decodes JWT payload (no signature verification — only for client-side expiry hints).
 */
export function decodeJwtPayload(token: string): Record<string, unknown> {
  try {
    const payload = token.split('.')[1];
    if (payload == null || payload === '') {
      return {};
    }
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - (normalized.length % 4)) % 4;
    const padded = normalized + '='.repeat(padLength);
    const decoded = atob(padded);
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    return {};
  }
}

export function isJwtExpired(token: string, skewSeconds = 120): boolean {
  const payload = decodeJwtPayload(token);
  const exp = payload['exp'];
  const seconds =
    typeof exp === 'number' ? exp : typeof exp === 'string' ? Number(exp) : Number.NaN;
  if (!Number.isFinite(seconds)) {
    return true;
  }
  return seconds * 1000 <= Date.now() + skewSeconds * 1000;
}
